export default label => ({
  required: true,
  message: `The ${label} field is required.`,
  trigger: 'blur',
})
